import { AxiosResponse } from "axios";
import { useApiRequest } from "../helper/api";

import {
  ClientOptionListResponseModel,
  getClientProjectOptionResponseModel,
  getclientlistResponseModel,
  getclientdetailpayload,
  getclientDetailResponseModel,
  createupdateResopnsePayload,
  createUpdateProjectClientPayloadModel,
} from "../model/clientmodel";
import { toast } from "react-toastify";

const useClientApi = () => {
  const { fetchData } = useApiRequest();

  const fetchGetClientOptionList = async (userID: number): Promise<ClientOptionListResponseModel | null> => {
    const response = await fetchData("/admin/get_items_to_add_client", {
      method: "POST",
      data: { user_id: userID },
    });
    if (response?.status) {
      return response.data;
    }
    return null;
  };

  const fetchGetProjectOption = async (): Promise<getClientProjectOptionResponseModel | null> => {
    const response = await fetchData("/admin/get_project_options", {
      method: "GET",
    });
    if (response?.status) {
      return response.data;
    }
    return null;
  };

  const fetchGetClientList = async (userID: number, status: number): Promise<getclientlistResponseModel[] | null> => {
    const response = await fetchData("/admin/get_client_list", {
      method: "POST",
      data: { user_id: userID, status },
    });
    if (response?.status) {
      return response.data;
    }
    return null;
  };

  const fetchGetClientDetail = async (
    payload: getclientdetailpayload,
  ): Promise<getclientDetailResponseModel | null> => {
    const response = await fetchData("/admin/get_client_details", {
      method: "POST",
      data: payload,
    });
    if (response?.status) {
      return response.data;
    }
    return null;
  };

  const createupdateClient = async (Payload: createupdateResopnsePayload): Promise<AxiosResponse | null> => {
    const response = await fetchData("/admin/add_update_client", {
      method: "POST",
      data: Payload,
    });
    if(response?.status){
      toast.success(response.data)
    }
    return response?.data;
  };

  const createupdateClientProject = async (
    Payload: createUpdateProjectClientPayloadModel,
  ): Promise<AxiosResponse | null> => {
    const response = await fetchData("/admin/upsert_project", {
      method: "POST",
      data: Payload,
    });
    if(response?.status){
      toast.success(response.data)
    }
    return response?.data;
  };

  return {
    fetchGetClientOptionList,
    fetchGetProjectOption,
    fetchGetClientList,
    fetchGetClientDetail,
    createupdateClient,
    createupdateClientProject,
  };
};

export default useClientApi;
